import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")

  return (_openBlock(), _createBlock(_component_SelectButton, {
    modelValue: _ctx.selectValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectValue = $event)),
    options: _ctx.selectOptions,
    dataKey: "value",
    optionLabel: "label",
    optionValue: "value"
  }, null, 8, ["modelValue", "options"]))
}